var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1365_16464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 29H58V58H29V29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 0V87H0V0H87ZM72.5 14.5H14.5V72.5H72.5V14.5ZM58 174H29V203H58V174Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 145V232H0V145H87ZM14.5 159.5V217.5H72.5V159.5H14.5ZM174 29H203V58H174V29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 0V87H232V0H145ZM217.5 14.5V72.5H159.5V14.5H217.5ZM116 14.5V0H130.5V29H116V58H101.5V14.5H116ZM116 87V58H130.5V87H116ZM87 116V101.5H101.5V87H116V116H130.5V101.5H203V116H145V130.5H101.5V116H87ZM87 116V130.5H29V116H14.5V130.5H0V101.5H43.5V116H87ZM232 130.5H217.5V101.5H232V130.5ZM217.5 130.5H203V159.5H232V145H217.5V130.5ZM159.5 130.5H188.5V145H174V159.5H159.5V130.5ZM188.5 174V159.5H174V174H159.5V188.5H130.5V203H174V174H188.5ZM188.5 174H232V188.5H203V203H188.5V174ZM130.5 159.5V174H145V145H101.5V159.5H130.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 174H116V217.5H174V232H101.5V174ZM232 203V232H188.5V217.5H217.5V203H232Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1365_16464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 232,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.f42e677b4bf4d1c80494a23105c47d58.svg";
export { ForwardRef as ReactComponent };